import classNames from "classnames";
import {
  BillingTier,
  PlanTerm,
} from "../../../../../../__generated__/gql/graphql";
import Card from "../../../../../../ui/Card/Card";
import { Check } from "../../../../../../ui/Icon/Icon";
import {
  billingTierLabel,
  billingTierRank,
} from "../../../../../../util/billing";
import styles from "./PlanTile.module.scss";
import Button from "../../../../../../ui/Button/Button";
import { useState } from "react";

export type PlanTileProps = {
  price: number;
  planTerm: PlanTerm;
  billingTier: BillingTier;
  features: string[];
  checked: boolean;
  onSubmit: () => Promise<void>;
  currentBillingTier: BillingTier;
};

function PlanTile({
  price,
  planTerm,
  billingTier,
  features,
  checked,
  onSubmit,
  currentBillingTier,
}: PlanTileProps) {
  const [loading, setLoading] = useState(false);
  const isCurrentPlan = billingTier === currentBillingTier;
  const isDowngrade =
    billingTierRank[billingTier] < billingTierRank[currentBillingTier];

  const onClick = async () => {
    setLoading(true);
    await onSubmit();
    setLoading(false);
  };

  return (
    <Card
      className={classNames(styles.card, {
        [styles.checked]: checked,
      })}
    >
      <div className={styles.label}>
        <div className={styles.row}>
          <p className={styles.price}>
            {price === Infinity ? "Custom" : `$${price}`}
          </p>
        </div>
        <p className={styles.plan}>{`${billingTierLabel[billingTier]} Plan`}</p>
        <p className={styles.period}>
          {planTerm === PlanTerm.Yearly
            ? "Per month, billed annually"
            : "Billed monthly"}
        </p>
        <ul className={styles.featuresList}>
          {features.map((feature) => (
            <li className={styles.feature} key={feature}>
              <Check className={styles.check} size="large" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        {price === Infinity ? (
          <Button
            variant="dark"
            onClick={onClick}
            className={styles.button}
            disabled={loading || isCurrentPlan}
            loading={loading}
          >
            {isCurrentPlan ? "Current plan" : "Contact us"}
          </Button>
        ) : (
          <Button
            disabled={loading || isCurrentPlan}
            loading={loading}
            variant="primary"
            onClick={onClick}
            className={styles.button}
          >
            {isCurrentPlan
              ? "Current plan"
              : isDowngrade
                ? "Downgrade"
                : "Select plan"}
          </Button>
        )}
      </div>
    </Card>
  );
}

export default PlanTile;
